import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AdminFormGroup } from "../../models/admin-form-group";
import { IInstanceConfiguration } from "../../models/future-deprecation/IInstanceConfiguration";

export class InstanceConfigForm extends AdminFormGroup {
  id = this.get('id') as FormControl;
  clientName = this.get('clientName') as FormControl;
  oktaClientId = this.get('oktaClientId') as FormControl;
  gxURL = this.get('gxURL') as FormControl;
  gxKey = this.get('gxKey') as FormControl;
  gxPassword = this.get('gxPassword') as FormControl;
  powerBIURL = this.get('powerBIURL') as FormControl;
  databaseConnectionString = this.get('databaseConnectionString') as FormControl;
  constructor(readonly instance: IInstanceConfiguration, readonly fb: FormBuilder = new FormBuilder()) {
    super(fb.group({
      id: [instance?.id, Validators.required],
      clientName: [instance.clientName, Validators.required],
      oktaClientId: [instance.oktaClientId, Validators.required],
      gxURL: [instance.gxURL, Validators.required],
      gxKey: [instance.gxKey, Validators.required],
      gxPassword: [instance.gxPassword, Validators.required],
      powerBIURL: [instance?.powerBIURL],     
      databaseConnectionString: [instance?.databaseConnectionString]
    }).controls);   
  }

  getItem(): IInstanceConfiguration {

    var instanceConfig= {
      id: this.id.value,
      clientName: this.clientName.value,
      oktaClientId: this.oktaClientId.value,
      gxURL: this.gxURL.value,
      gxKey: this.gxKey.value,
      gxPassword: this.gxPassword.value,    
      powerBIURL: this.powerBIURL.value,
      databaseConnectionString: this.databaseConnectionString.value,
    }
   
    return instanceConfig;
  }

}

